import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store/store'
import vuetify from './plugins/vuetify'
import Notifications from 'vue-notification'
import velocity from 'velocity-animate'
import AuthService from './auth/AuthService'
import VueMask from 'v-mask'
import './plugins/filters'
import VueCookies from 'vue-cookies'
import Editor from 'v-markdown-editor'
import 'v-markdown-editor/dist/v-markdown-editor.css';
import VueResource from "vue-resource";
import { createNavigationGuard } from './router/navigationGuard'
// import Markdown from 'vue3-markdown-it';
// import markdown from './directives/markdown' 

// Importing all css styles
// import './lib/globalCss'
router.beforeEach(createNavigationGuard({ store, AuthService, storage: localStorage }))

window.addEventListener('auth:expired', () => {
  store.commit('logoutUser')
  if (router.currentRoute.path !== '/session/login') {
    router.push('/session/login')
  }
})

router.afterEach((to, from) => {
  setTimeout(() => {
    const contentWrapper = document.querySelector('.v-main__wrap, .v-content__wrap');
		if (contentWrapper !== null) {
      contentWrapper.scrollTop = 0;
		}
		const boxedLayout = document.querySelector('.app-boxed-layout .app-content');
		if (boxedLayout !== null) {
      boxedLayout.scrollTop = 0;
		}
		const miniLayout = document.querySelector('.app-mini-layout .app-content');
		if (miniLayout !== null) {
      miniLayout.scrollTop = 0;
		}
	}, 200);
})

Vue.config.productionTip = false
Vue.use(VueResource);
// Vue.directive('makrdown', markdown)
Vue.use(Notifications, { velocity })
Vue.use(VueMask);
Vue.use(VueCookies)
Vue.use(Editor);
// Vue.use(Markdown);

Vue.$cookies.config(60, '')


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
